import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Section, Title } from "@/components/UI";
import { useI18n } from "@/shared/hooks";
import { FloorplanOverlay, FloorplanPreview, useFloorplans, } from "@/components/Sections/Floorplan";
import { TAB_ITEMS } from "@/components/UI/Tabs/contants";
import { useGalleryContext } from "@/gallery/contexts";
export const floorplanTestId = "cdp-floorplan";
export const Floorplan = () => {
    const { t } = useI18n();
    const { floorplansMobilePreview, floorplansCount } = useFloorplans();
    const { updateTab, openSliderModal } = useGalleryContext();
    const onClick = () => {
        updateTab(TAB_ITEMS.FLOORPLANS);
        openSliderModal();
    };
    if (floorplansCount === 0)
        return null;
    return (_jsxs(Section, { id: "floorplan", testId: floorplanTestId, children: [_jsx(Title, { title: t("floorplan.preview.title"), testId: `${floorplanTestId}-title`, variant: "section" }), _jsxs(Box, { display: "flex", testId: `${floorplanTestId}-preview-container`, overflow: ["hidden", "clip"], paddingRight: {
                    "breakpoint.base": "spacing.4",
                }, paddingTop: "spacing.6", justifyContent: "center", position: "relative", onClick: onClick, children: [_jsx(FloorplanOverlay, { countInfo: `1 / ${floorplansCount}`, onClick: onClick }), _jsx(FloorplanPreview, { floorplan: floorplansMobilePreview[0] })] })] }));
};
